var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"filter-bar-secondary"},[(_vm.urlParam.length > 1)?_c('div',{class:[
            'filter-bar-active',
            _vm.tsMobileView
                ? 'filter-bar-active-mobile'
                : 'filter-bar-active-desktop',
        ]},[_c('div',{staticClass:"filter-bar-active-container"},[_c('div',{staticClass:"filter-rule",on:{"click":function($event){return _vm.removeParamFilter()}}},[_vm._v(" "+_vm._s(_vm.formatLabel(_vm.urlParam))+" "),_c('span',{staticClass:"del"},[_vm._v("×")])])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }